import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MapPin, Phone } from 'lucide-react';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="text-gray-800 py-20 relative border-t border-gray-300">
      {/* Background image */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url('/assets/carnival/WechatIMG21.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gray-100/90" />
      <div className="absolute inset-0 bg-gradient-to-t from-gray-200/50 to-transparent" />
      <div className="section-padding relative z-10 pt-8 md:pt-12 lg:pt-16">
        {/* Logo Section */}
        <div className="flex justify-center mb-12">
          <img 
            src="/assets/carnival_logo.PNG" 
            alt="Carnival Restaurant Logo" 
            className="h-24 md:h-32 w-auto object-contain"
          />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 px-4 md:px-8 lg:px-12">

          <div>
            <h4 className="text-xl font-display mb-6 text-gray-800">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-base text-gray-600 hover:text-carnival-burgundy transition-colors duration-300 font-body">
                  {t('navHome')}
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-base text-gray-600 hover:text-carnival-burgundy transition-colors duration-300 font-body">
                  {t('navGallery')}
                </Link>
              </li>
              <li>
                <Link to="/location" className="text-base text-gray-600 hover:text-carnival-burgundy transition-colors duration-300 font-body">
                  {t('navLocation')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-display mb-6 text-carnival-charcoal">{t('navContact')}</h4>
            <div className="space-y-4 text-base text-carnival-charcoal/70 font-body">
              <p className="flex items-start gap-2">
                <MapPin className="mt-1 flex-shrink-0" size={29} />
                <span>
                  18 Bd d'Alsace Lorraine<br />
                  51350 Cormontreuil
                </span>
              </p>
              <p className="flex items-center gap-2">
                <Phone size={29} />
                <a href="tel:0326502026" className="hover:text-carnival-gold transition-colors duration-300">
                  03 26 50 20 26
                </a>
              </p>
              <p className="text-sm mt-2 text-carnival-charcoal/60">
                {t('noReservation')}
              </p>
            </div>
          </div>
        </div>

        <div className="luxury-divider my-12" />

        <div className="text-center">
          <p className="text-carnival-charcoal/50 text-sm font-body tracking-wide">
            &copy; 2024 Carnival • {t('openSevenDays')}
          </p>
          <div className="text-carnival-charcoal/50 text-sm font-body tracking-wide mt-2">
            <Link 
              to="/legal" 
              className="hover:text-carnival-gold transition-colors duration-300"
            >
              {t('navLegal')}
            </Link>
            <span className="mx-2">•</span>
            <span>Made by <a href="https://artemis-marketing.net/" target="_blank" rel="noopener noreferrer" className="hover:text-carnival-gold transition-colors duration-300">Odyssey</a></span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;